import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-replace-image-url-dialog',
  templateUrl: './replace-image-url-dialog.component.html',
  styleUrls: ['./replace-image-url-dialog.component.scss']
})
export class ReplaceImageUrlDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
